export default __webpack_public_path__ + "static/media/gallery_02.00b1c863.jpg";